var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-histogram-chart"},[_c('ve-histogram',{attrs:{"data":_vm.chartData,"settings":_vm.chartSettings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }